import React, { useState } from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import { TabCarouselSectionStoryblok } from '../../../../types/storyblok';
import { TabCarouselCard } from './components/TabCarouselCard/TabCarouselCard';
import { Type } from '../../../../base/Type/Type';
import { Box } from '../../../../base/Box/Box';
import { Button } from '../../../../base/Button/Button';

type Props = Pick<TabCarouselSectionStoryblok, 'cards'>;

export const TabCarouselContentMobile = ({ cards }: Props) => {
  if (!cards) {
    return null;
  }

  const [itemOpen, setItemOpen] = useState(cards[0]?._uid);

  return (
    <Accordion.Root
      type="single"
      collapsible
      className="flex flex-col md:hidden mt-12"
      value={itemOpen}
      onValueChange={setItemOpen}
    >
      {cards.map((card) => (
        <Accordion.Item
          key={card?._uid}
          value={card?._uid}
          className="border-t border-t-ffLightGrey py-5"
        >
          <Accordion.Header>
            <Accordion.Trigger asChild className="w-full">
              <Box
                as="div"
                className="flex items-center justify-between px-4 py-2 w-full"
              >
                <Type as="h2" className="font-foundersGrotesk text-2xl">
                  {card?.tabTitle}
                </Type>

                <Button
                  type="button"
                  variant={
                    card?._uid === itemOpen
                      ? 'naked-arrow-up'
                      : 'naked-arrow-down'
                  }
                  className="ml-3 !h-12 !w-12"
                />
              </Box>
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content>
            <TabCarouselCard {...card} />
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
};
